// hooks/useProjects.ts
import { useState, useEffect } from 'react';
import { getAllProjects, Project } from '../pages/projects/data';

export const useProjects = (slug: string | undefined) => {
  const [allProjects, setAllProjects] = useState<Project[]>([]);
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAllProjects = async () => {
      try {
        const projects = await getAllProjects();
        setAllProjects(projects);
        if (slug) {
          const foundProject = projects.find((p) => p.slug === slug);
          if (foundProject) {
            setProject(foundProject);
          } else {
            setError('Project not found');
          }
        }
      } catch (err) {
        setError('Failed to fetch projects');
      } finally {
          setLoading(false);
      }
    };

    fetchAllProjects();
  }, [slug]);

  return { allProjects, project, loading, error };
};
